module.exports = __webpack_public_path__ + "img/tv-image2.4415cefc.jpg";